import React from 'react';
import { motion } from 'framer-motion';
import { Star, XCircle } from 'lucide-react';
import { ScrollButton } from './Shared';
const stats = [{
  value: '+500',
  label: 'insegnanti si fidano'
}, {
  value: '12+6',
  label: 'Tomi + Bonus'
}, {
  value: '4.9/5',
  label: 'valutazione ⭐',
  isRating: true
}];
const initialTestimonials = [{
  initials: 'MP',
  quote: 'Ho organizzato tutto il mese in un pomeriggio. Non arrivo mai più in studio senza sapere cosa insegnare.',
  author: 'María P., Milano',
  role: 'Insegnante di Pilates in Studio Proprio'
}, {
  initials: 'CG',
  quote: 'I miei allievi di livello intermedio sono progrediti più in un mese che nei tre precedenti.',
  author: 'Claudia G., Roma',
  role: 'Insegnante di Pilates in Accademia Privata'
}, {
  initials: 'FR',
  quote: 'Prima impiegavo 1 ora per preparare una sessione. Ora ci metto 5 minuti.',
  author: 'Federico R., Napoli',
  role: 'Insegnante di Pilates Reformer Indipendente'
}];
const painPoints = ['Arrivi in studio senza sapere esattamente quale sessione insegnerai', "I tuoi allievi non progrediscono perché non c'è un ordine chiaro dei contenuti né una progressione reale", 'Hai gruppi con livelli misti e non sai come gestirli senza che nessuno rimanga indietro', "Quando c'è una festività o un'assenza perdi la continuità della pratica e tutto si disordina", 'Non puoi giustificare un aumento di prezzo perché non hai nulla di sistematizzato né documentato', 'Usi sempre gli stessi esercizi perché sei a corto di idee e non sai come variare', 'Torni a casa mentalmente esausta non per aver insegnato ma per aver dovuto improvvisare', 'Nessuno valorizza il tuo lavoro perché non si riflette nel progresso concreto dei tuoi allievi'];
export const Problem = () => {
  return <>
      {/* Dark Social Proof + Testimonials Section */}
      <section className="bg-brand-charcoal py-16 sm:py-20" data-id="element-152">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-y-10 gap-x-6 mb-16 sm:mb-20" data-id="element-154">
            {stats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="text-center" data-id="element-155">
                <div className={`font-serif font-bold text-white mb-2 text-4xl sm:text-5xl md:text-6xl`} data-id="element-156">
                  {stat.value}
                </div>
                <div className="text-brand-terracotta text-sm sm:text-base font-medium flex items-center justify-center gap-1" data-id="element-157">
                  {stat.isRating ? <>
                      valutazione{' '}
                      <Star className="text-brand-gold fill-current inline" size={16} data-id="element-158" />
                    </> : stat.label}
                </div>
              </motion.div>)}
          </div>

          {/* Initial Testimonials */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-159">
            {initialTestimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-2xl p-6" data-id="element-160">
                <div className="flex items-center gap-3 mb-5" data-id="element-161">
                  <div className="w-10 h-10 bg-brand-terracotta/20 text-brand-terracotta rounded-full flex items-center justify-center font-bold text-sm border border-brand-terracotta/30" data-id="element-162">
                    {t.initials}
                  </div>
                  <div className="flex gap-0.5" data-id="element-163">
                    {[...Array(5)].map((_, j) => <Star key={j} className="text-brand-gold fill-current" size={14} data-id="element-164" />)}
                  </div>
                </div>
                <p className="text-white leading-relaxed mb-5 text-[15px]" data-id="element-165">
                  "{t.quote}"
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-166">
                  — {t.author} | {t.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Pain Points */}
      <section className="py-20 bg-brand-cream" data-id="element-167">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-brand-sand" data-id="element-169">
            <div className="bg-brand-charcoal text-white p-10 text-center" data-id="element-170">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-171">
                Se sei un insegnante di Pilates, questo ti suonerà familiare:
              </h2>
            </div>

            <div className="p-8 md:p-12" data-id="element-172">
              <div className="space-y-6 mb-12" data-id="element-173">
                {painPoints.map((point, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-174">
                    <XCircle className="text-red-500 flex-shrink-0 mt-1" size={24} data-id="element-175" />
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-176">
                      <span className="font-semibold text-brand-charcoal" data-id="element-177">
                        ❌
                      </span>{' '}
                      {point}
                    </p>
                  </motion.div>)}
              </div>

              <div className="text-center" data-id="element-178">
                <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 italic" data-id="element-179">
                  "Quante altre sessioni improvviserai?"
                </h3>
                <ScrollButton className="w-full sm:w-auto bg-brand-charcoal hover:bg-black text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1" data-id="element-180">
                  👉 BASTA IMPROVVISARE — VOGLIO IL MIO PILATES 360
                </ScrollButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};